module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardClass
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": _vm.backgroundColor
    }
  }, [(!_vm.hasHeaderSlot) ? _c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (!_vm.hasHeaderSlot) ? _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.category))]) : _vm._e(), _vm._t("header")], 2), _c('div', {
    staticClass: "card-content",
    class: {
      'table-responsive': _vm.hasTable
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b004c106","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdCard/index.vue
// module id = 1JJN
// module chunks = 13 14